import { cardSchema, type Card, type CreateCardBody } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postCard = (body: CreateCardBody): Promise<unknown> =>
  apiRequest<unknown>('/cards', { method: 'POST', body });

export const createCard = async (body: CreateCardBody): Promise<Card> =>
  cardSchema.parse(await postCard(body));
